module.exports = "../../../../platform/assets/pageMainIcon/yewushezhilei7.svg";